import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateCardComponent } from './candidate-card.component';
import { TooltipModule, PopoverModule, BsDropdownModule, ModalModule } from 'ngx-bootstrap';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { CandidateCardIconsModule } from 'src/app/shared/candidate-card-icons/candidate-card-icons.module';
import { RecentActivitiesModule } from 'src/app/shared/recent-activities/recent-activities.module';
import { CandidateActionsModule } from 'src/app/shared/candidate-actions/candidate-actions.module';
import { NotificationsPageModule } from '../../notifications-page/notifications-page.module';
import { CandidateCardActionsModalComponent } from './candidate-card-actions-modal/candidate-card-actions-modal.component';
import { NotesAndCommunicationModule } from 'src/app/shared/candidate-actions/notes-and-communication/notes-and-communication.module';
import { UserCommunicationModule } from 'src/app/shared/user-communication/user-communication.module';
import { EntityActivitiesModule } from 'src/app/shared/entity-activities/entity-activities.module';
import { SetCandidateAvailabilityOrJobLeftDateModule } from 'src/app/shared/set-candidate-availability-or-job-left-date/set-candidate-availability-or-job-left-date.module';
import { JobLeftModule } from 'src/app/shared/job-left/job-left.module';
import { DeleteEntityModule } from 'src/app/shared/delete-entity/delete-entity.module';
import { AddEditCandidateContactModule } from 'src/app/shared/add-edit-candidate-contact/add-edit-candidate-contact.module';
import { JobProfileModule } from '../../job-profile-page/job-profile/job-profile.module';
import { DoNotHireModule } from 'src/app/shared/do-not-hire/do-not-hire.module';
import { EmailClientReviewModule } from 'src/app/shared/email-client-review/email-client-review.module';
import { SendCandidateOutreachEmailModule } from 'src/app/shared/send-candidate-outreach-email/send-candidate-outreach-email.module';
import { AddCandidatesModule } from '../../add-candidates-page/add-candidates/add-candidates.module';
import { CandidateJobMatchProfileModule } from 'src/app/shared/candidate-job-match-profile/candidate-job-match-profile.module';
import { EmailDocumentsModule } from '../../candidateprofile-page/email-documents/email-documents.module';

@NgModule({
  declarations: [CandidateCardComponent, CandidateCardActionsModalComponent],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PipesModule,
    CandidateCardIconsModule,
    RecentActivitiesModule,
    CandidateActionsModule,
    NotificationsPageModule,
    NotesAndCommunicationModule,
    UserCommunicationModule,
    EntityActivitiesModule,
    SetCandidateAvailabilityOrJobLeftDateModule,
    JobLeftModule,
    DeleteEntityModule,
    AddEditCandidateContactModule,
    JobProfileModule,
    DoNotHireModule,
    EmailClientReviewModule,
    SendCandidateOutreachEmailModule,
    AddCandidatesModule,
    CandidateJobMatchProfileModule,
    EmailDocumentsModule
  ],
  exports: [CandidateCardComponent],
  entryComponents: [CandidateCardComponent, CandidateCardActionsModalComponent]
})
export class CandidateCardModule { }
